import { useFormikContext } from "formik";
import { FormattedMessage } from "react-intl";
import { useQuery } from "react-query";
import { simpleQuery } from "../../services/utils";
import { StatusMessage } from "./StatusMessage";

const MIN_STAY_ACTION_IDS = [6, 7]; // MIN_STAY_REMOVE, MIN_STAY_SET

/**
 * Shows a warning when min-stay actions are selected but some
 * of the chosen properties don't have a PMS connector that
 * supports sending restrictions.
 */
export const AutopilotMinStayWarning = () => {
  const { values } = useFormikContext<any>();

  const selectedActions: any[] = values.actions || [];
  const selectedProperties: any[] = values.properties || [];

  const hasMinStayAction = selectedActions.some((a) =>
    MIN_STAY_ACTION_IDS.includes(a.id ?? a.data)
  );

  const { data } = useQuery(
    ["connectors-properties-support", "restrictions"],
    () =>
      simpleQuery(
        "/api/connectors/properties-support/?capability=restrictions"
      ),
    {
      enabled: hasMinStayAction,
      staleTime: 60_000,
    }
  );

  if (!hasMinStayAction) return null;

  // No specific properties selected means "all properties" - show a generic warning
  if (selectedProperties.length === 0) {
    return (
      <StatusMessage status="warning">
        <FormattedMessage id="AUTOPILOT_MIN_STAY_WARNING_GENERIC" />
      </StatusMessage>
    );
  }

  if (!data) return null;

  const supportedIds = new Set(data.supported_property_ids);
  const unsupported = selectedProperties.filter(
    (p) => !p.isHardCodedOption && !supportedIds.has(p.id ?? p.data)
  );

  if (unsupported.length === 0) return null;

  return (
    <StatusMessage status="warning">
      <FormattedMessage
        id="AUTOPILOT_MIN_STAY_WARNING_PROPERTIES"
        values={{
          properties: unsupported.map((p) => p.label).join(", "),
        }}
      />
    </StatusMessage>
  );
};
